/**
 * The openings circulation reads: where people walk, which landings stay
 * clear. Normally the room's own `openings`. A continuation that stands in a
 * wide opening narrows that opening FOR CIRCULATION ONLY — the room it is
 * planned in carries `circulationOpenings` (in memory, never saved), so the
 * doorway zones and the walkway planner see the stretch left open, while the
 * wall's own segments still stop at the opening the room has.
 * (`continuations/enumerateContinuations`, `circulationRoom`.)
 */
function circulationOpeningsOf(room) {
  return room?.circulationOpenings || room?.openings || [];
}

module.exports = { circulationOpeningsOf };
